"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var initialState = {
  loadUserApps: {
    data: null,
    isLoading: false,
    error: null
  },
  pullUserApps: {
    isLoading: false,
    success: null,
    error: null
  },
  deleteUserApp: {
    deletedAppName: null,
    isLoading: false,
    error: null
  }
};
exports.initialState = initialState;

var appsReducer = function appsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case 'OLY_LOAD_USER_APPS':
      return _objectSpread({}, state, {
        loadUserApps: _objectSpread({}, initialState.loadUserApps, {
          isLoading: true
        })
      });

    case 'OLY_LOAD_USER_APPS_SUCCESS':
      return _objectSpread({}, state, {
        loadUserApps: _objectSpread({}, initialState.loadUserApps, {
          data: action.payload.loadUserApps
        })
      });

    case 'OLY_LOAD_USER_APPS_ERROR':
      return _objectSpread({}, state, {
        loadUserApps: _objectSpread({}, initialState.loadUserApps, {
          error: action.payload.error
        })
      });

    case 'OLY_PULL_USER_APPS':
      return _objectSpread({}, state, {
        pullUserApps: _objectSpread({}, initialState.pullUserApps, {
          isLoading: true
        })
      });

    case 'OLY_PULL_USER_APPS_SUCCESS':
      return _objectSpread({}, state, {
        pullUserApps: _objectSpread({}, initialState.pullUserApps, {
          success: true
        })
      });

    case 'OLY_PULL_USER_APPS_ERROR':
      return _objectSpread({}, state, {
        pullUserApps: _objectSpread({}, initialState.pullUserApps, {
          error: action.payload.error
        })
      });

    case 'OLY_DELETE_USER_APP':
      return _objectSpread({}, state, {
        deleteUserApp: _objectSpread({}, initialState.deleteUserApp, {
          isLoading: true
        })
      });

    case 'OLY_DELETE_USER_APP_SUCCESS':
      return _objectSpread({}, state, {
        deleteUserApp: _objectSpread({}, initialState.deleteUserApp, {
          deletedAppName: action.payload.deletedAppName
        })
      });

    case 'OLY_DELETE_USER_APP_ERROR':
      return _objectSpread({}, state, {
        deleteUserApp: _objectSpread({}, initialState.deleteUserApp, {
          error: action.payload.error
        })
      });

    case 'OLY_USER_APP_RESET':
      return initialState;

    default:
      return state;
  }
};

var _default = appsReducer;
exports["default"] = _default;
//# sourceMappingURL=reducers.js.map